import { Upload } from '@/bundles/Upload/models/Upload';
import { IBaseMapper } from '@/bundles/App/interfaces/IBaseMapper';
import { IUploadFile } from '@/bundles/Upload/interfaces';

export class UploadToMapper implements IBaseMapper<IUploadFile> {
  mapToModel (data: any) {
    return new Upload(data);
  }
}
